// WAKO theme — spray tag on click + reveal on scroll
(function(){
  var cv = document.getElementById('spray');
  if(cv){
    var ctx = cv.getContext('2d');
    var fit = function(){ cv.width = innerWidth; cv.height = innerHeight; };
    fit(); addEventListener('resize', fit);
    var sprayColors = ['#6a1fbf','#e8871f','#b8c422','#c22f1e'];
    var colorIdx = 0;
    document.addEventListener('click', function(e){
      if(e.target.closest('a,button,input,select,label,form')) return;
      var x = e.clientX, y = e.clientY;
      ctx.fillStyle = sprayColors[colorIdx++ % sprayColors.length];
      for(var i=0;i<90;i++){
        var ang = Math.random()*Math.PI*2;
        var rad = Math.pow(Math.random(),2)*36;
        ctx.globalAlpha = Math.random()*.6+.2;
        ctx.beginPath();
        ctx.arc(x+Math.cos(ang)*rad, y+Math.sin(ang)*rad, Math.random()*3+0.5, 0, 7);
        ctx.fill();
      }
      for(var j=0;j<3;j++){
        ctx.globalAlpha = .45;
        ctx.fillRect(x+(Math.random()-0.5)*36, y, 1.5, Math.random()*44+10);
      }
      ctx.globalAlpha = 1;
    });
  }

  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){
          en.target.animate([
            {transform:'translateY(12px)',opacity:0},
            {transform:'translateY(0)',opacity:1}
          ],{duration:400,easing:'ease-out'});
          io.unobserve(en.target);
        }
      });
    },{threshold:.25});
    document.querySelectorAll('.prod,.arch').forEach(function(el){ io.observe(el); });
  }
})();
